import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { getKey } from '../utils/uid';
import Button from '../Button';
import { Component } from '../component';
import { transferClass } from './styles';
import icons from '../icons';
import { isRTL } from '../config';

var Btns =
/*#__PURE__*/
function (_Component) {
  _inherits(Btns, _Component);

  var _super = _createSuper2(Btns);

  function Btns(props) {
    var _this;

    _classCallCheck(this, Btns);

    _this = _super.call(this, props);
    _this.toSource = void 0;
    _this.toTarget = void 0;
    _this.toSource = _this.change.bind(_assertThisInitialized(_this), 0);
    _this.toTarget = _this.change.bind(_assertThisInitialized(_this), 1);
    return _this;
  }

  _createClass(Btns, [{
    key: "getDataMap",
    value: function getDataMap() {
      var _this$props = this.props,
          data = _this$props.data,
          keygen = _this$props.keygen;
      var dataMap = new Map();

      for (var i = 0; i < data.length; i++) {
        dataMap.set(getKey(data[i], keygen, i), data[i]);
      }

      return dataMap;
    }
  }, {
    key: "change",
    value: function change(index) {
      var _this$props2 = this.props,
          setSelecteds = _this$props2.setSelecteds,
          selecteds = _this$props2.selecteds,
          datum = _this$props2.datum;
      var dataMap = this.getDataMap();
      var newValue = selecteds[1 - index].map(function (c) {
        return dataMap.get(c);
      }); // const newValue = selecteds[1 - index].map(c => data.find((d, i) => getKey(d, keygen, i) === c))

      setSelecteds(1 - index, []);
      datum[index ? 'add' : 'remove'](newValue, undefined, undefined, true);
    }
  }, {
    key: "renderButtonText",
    value: function renderButtonText() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'left';
      var _this$props3 = this.props,
          operations = _this$props3.operations,
          operationIcon = _this$props3.operationIcon;

      if (mode === 'left') {
        var left = [
        /*#__PURE__*/
        React.createElement(React.Fragment, {
          key: "operationIcon"
        }, operationIcon && icons.AngleLeft),
        /*#__PURE__*/
        React.createElement(React.Fragment, {
          key: "operations"
        }, operations[1])];
        if (isRTL()) return left.reverse();
        return left;
      }

      var right = [
      /*#__PURE__*/
      React.createElement(React.Fragment, {
        key: "operationIcon"
      }, operationIcon && icons.AngleRight),
      /*#__PURE__*/
      React.createElement(React.Fragment, {
        key: "operations"
      }, operations[0])];
      if (isRTL()) return right.reverse();
      return right;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          selecteds = _this$props4.selecteds,
          disabled = _this$props4.disabled;
      var disable = disabled === true;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: transferClass('btns')
        },
        /*#__PURE__*/
        React.createElement("div", null,
        /*#__PURE__*/
        React.createElement(Button, {
          type: "primary",
          disabled: disable || !selecteds[0].length,
          size: "small",
          className: transferClass('btns-button', 'btns-bottom'),
          onClick: this.toTarget
        }, this.renderButtonText('right')),
        /*#__PURE__*/
        React.createElement("br", null),
        /*#__PURE__*/
        React.createElement(Button, {
          type: "primary",
          disabled: disable || !selecteds[1].length,
          size: "small",
          className: transferClass('btns-button'),
          onClick: this.toSource
        }, this.renderButtonText('left'))))
      );
    }
  }]);

  return Btns;
}(Component);

export default Btns;